<!--
페이지 내 서브그룹을 나타내기 위한 레이아웃
타이틀과 버튼, 바디로 구성되어있음
-->
<template>
    <div class="uk-padding-small">
        <div class="uk-margin-small-bottom uk-flex uk-flex-between uk-flex-bottom" style="border-bottom: 1px solid #666">
            <h5 class="uk-margin-remove" >
                <i class="material-icons uk-text-middle">
                    {{ icon }}
                </i>
                <span class="uk-text-middle">
                    {{ header }}
                </span>
            </h5>

            <slot name="button"></slot>
        </div>


        <slot name="body"></slot>

    </div>

</template>

<script>
    export default {
        props: {
            /**
             * 마테리얼 아이콘
             */
            icon: {
                type: String,
                default: null,
            },
            /**
             * 헤더
             */
            header: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {

            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
</style>